import TableExclusionHistory from "./components/table/TableExclusionHistory";

export default function ExclusionHistoryRegisterPage() {
    return <TableExclusionHistory />;
}
